import React from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

const Index = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();

  const pass = watch("password", "");

  const onSubmit = (data) => {
    console.log(data);
  };

  return (
    <div className="container mx-auto h-screen flex justify-center items-center w-12/12">
      <div className="md:w-4/12 w-12/12">
        <div>
          <h6 className="font-bold text-center mb-5">
            <img
              src="https://materialpro-vue3-admin.vercel.app/assets/dark-logo-icon.2f396e35.svg"
              alt="logo"
              className="mx-auto"
            />
          </h6>
          <h1 className="font-bold text-2xl text-center">Register</h1>
        </div>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="w-full flex flex-col justify-center items-center"
        >
          <input
            type="text"
            className="input input-bordered w-full focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm mt-5"
            placeholder="Company Name"
            {...register("compnay_name", {
              required: {
                message: "Company Name Is Required!",
              },
            })}
          />
          {errors?.company_name?.message && (
            <p className="text-red-600 self-start">
              {errors.company_name.message}
            </p>
          )}
          <input
            type="text"
            className="input input-bordered w-full focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm mt-5"
            placeholder="Your Name"
            {...register("client_name", {
              required: {
                message: "Your Name is Required!",
              },
            })}
          />
          {errors?.client_name?.message && (
            <p className="text-red-600 self-start">
              {errors.client_name.message}
            </p>
          )}
          <input
            type="email"
            className="input input-bordered w-full focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm mt-5"
            placeholder="Email"
            {...register("email", {
              required: {
                message: "Email Is Required!",
              },
              pattern: {
                value: /^\S+@\S+$/i,
                message: "Only Email Can Be Input Here",
              },
            })}
          />
          {errors?.email?.message && (
            <p className="text-red-600 self-start">{errors.email.message}</p>
          )}
          <input
            type="password"
            className="input input-bordered w-full  focus:border-gray-800 focus:border-2    focus:outline-none rounded-sm mt-5"
            placeholder="Password"
            {...register("password", {
              required: {
                message: "Password Is Required!",
              },
              min: {
                value: 8,
                message: "Minimum length is 8",
              },
              max: {
                value: 16,
                message: "Maximum length is 16",
              },
              validate: {
                validating: (value) => {
                  const regex =
                    /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/g;
                  return (
                    regex.test(value) ||
                    "Password Must Contain 1 Uppercase, Smallcase, Numeric, Special Character and at least 8 character long."
                  );
                },
              },
            })}
          />
          {errors?.password?.message && (
            <p className="text-red-600 self-start">
              {errors.password.message}!
            </p>
          )}

          <input
            type="password"
            className="input input-bordered w-full  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm mt-5"
            placeholder="Confirm Password"
            {...register("confirm_password", {
              required: {
                message: "Confirm password is required!",
              },
              validate: (value) => value === pass || "Passwords do not match",
            })}
          />
          {errors?.confirm_password?.message && (
            <p className="text-red-600 self-start">
              {errors.confirm_password.message}!
            </p>
          )}

          <input
            type="submit"
            value="Log in"
            className="btn btn-block focus:outline-none rounded-sm mt-5"
          />
        </form>
        <p className="mt-5">
          Don't Have An Account?
          <Link to="/login" className="text-blue-500 hover:underline ml-2">
            Login
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Index;
